import { Alert, AlertDescription } from "@common/components/ui/alert"
import { Button } from "@common/components/ui/button"
import Refresh from "~icons/material-symbols/refresh"

export function LoadMoreError({
  message,
  onRetry,
}: {
  message: string
  onRetry: () => void
}): React.ReactElement {
  return (
    <Alert
      variant="destructive"
      className="flex items-center justify-between gap-4"
    >
      <AlertDescription className="text-destructive">
        {message}
      </AlertDescription>
      <Button variant="outline" size="sm" onClick={onRetry}>
        <Refresh />
        Retry
      </Button>
    </Alert>
  )
}
